document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('bulk-sticky-bar');
  if (!stickyBar) return;

  const triggerOffset = 300; // px scroll before showing

  window.addEventListener('scroll', () => {
    if (window.scrollY > triggerOffset) {
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }
  });
});
